import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=0af8a1c7&scoped=true"
import script from "./Shared.vue?vue&type=script&lang=js"
export * from "./Shared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af8a1c7",
  null
  
)

export default component.exports